
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SearchArticle } from '@/common/api/models.pleased';
import HeadArrowUpIcon from './icons/HeadArrowUpIcon.vue';
import { markSearchTextToHtml } from '@/vendor/pleased-sdk/util';

@Component({
  components: {
    HeadArrowUpIcon,
  },
})
export default class ArticleListItem extends Vue {
  @Prop() readonly item!: SearchArticle;
  @Prop({ type: String, default: null }) readonly highlightQuery!: string | null;

  get itemTitle () {
    const title = this.item.title ?? this.item.titleTranslated;

    if (this.highlightQuery) {
      return markSearchTextToHtml(title, this.highlightQuery)
    }

    return title;
  }
}
